<template>
  <div class="agreement-layout">
    <div v-html="content"></div>
  </div>
</template>
<script>
import { httpOpen } from "../../scripts/network.js";
export default {
  data() {
    return {
      content: "",
    };
  },
  async mounted() {
    try {
      //   let id = this.$route;
      let sysNo = this.$route.query.SysNo;
      let module = this.$route.query.Module;
      const body = {
          SysNo:sysNo,
          Module:module,
          Platform:2
      };

	    if(sysNo){
          body.Platform=0;
      }
      const ret = await httpOpen("/Common/GetPolicy", {
        type: "post",
        body: body,
      });
      if (ret.Status) {
        this.content = ret.Data.Content;
      }
    } catch (e) {
      console.error(e);
    }
  },
};
</script>
<style lang="less" scoped>
.agreement-layout{
  padding: 10px;
}
</style>
<style scoped>
  .agreement-layout >>> h1{
    border: none;
  }
</style>
